import { NewsComponent } from './news.component';
import { ShippingTqComponent } from './shipping-tq';
import {HotNewsComponent} from './hotnews/hotnews.component';
import { NewsDetailsComponent } from './news-details/news-details.component'

export const routes = [
  { path: '', component: NewsComponent, children: [
    { path: '', redirectTo: 'tq', pathMatch: 'full' },
    { path: 'tq', component: ShippingTqComponent },
  ]},
  { path:'tin-tuc-moi',component:HotNewsComponent },
  { path:'chitiet/:id',component:NewsDetailsComponent}
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/news/news.routes.ts